/**
 * Rút gọn số lớn kiểu mạng xã hội: 1.5k, 12k, 1.2tr (locale Việt).
 */

/** @param {number|string} count */
export const formatCompactCount = (count) => {
  const value = Number(count || 0);

  if (value >= 1_000_000) {
    return `${(value / 1_000_000).toFixed(1).replace(/\.0$/, '')}tr`;
  }

  if (value >= 10_000) {
    return `${Math.round(value / 1000)}k`;
  }

  if (value >= 1_000) {
    return `${(value / 1000).toFixed(1).replace(/\.0$/, '')}k`;
  }

  return String(value);
};
